var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('event-item-form', {
    attrs: {
      "error": _vm.error,
      "responsibles": _vm.responsibles,
      "locations": _vm.locations,
      "topics": _vm.topics,
      "event-item": _vm.item,
      "max-date-time": _vm.maxDateTime,
      "locations-loading": _vm.locationsLoading,
      "topics-loading": _vm.topicsLoading,
      "responsibles-loading": _vm.responsiblesLoading
    },
    on: {
      "submit": _vm.onSubmit,
      "on-delete": _vm.onDelete
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }